import React from "react";
// Swiper
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/scrollbar";
import "swiper/css/effect-fade";
import "swiper/css/effect-flip";
import { Pagination,EffectCoverflow, Autoplay } from "swiper/modules";

const SliderSwiper=({images})=>{    
    return(
    <Swiper effect={"coverflow"} grabCursor={true} centeredSlides={true} slidesPerView={"4"} loop={false} autoplay={{delay: 200000,
        disableOnInteraction: true}} coverflowEffect={{rotate: 50,stretch: 0,depth: 100, modifier: 1,slideShadows: true,}}pagination={{el: ".swiper-pagination",clickable: true,
        dynamicBullets: true,}} modules={[EffectCoverflow, Pagination, Autoplay]} className="mySwiper swiper effect-coverflow-swiper rounded pb-5" >
      {images.map((imageUrl, index) => (
        <SwiperSlide key={index}>
          <img src={imageUrl} alt="" className="img-fluid" />
        </SwiperSlide>
      ))}
      <div className="swiper-pagination swiper-pagination-dark"></div>
    </Swiper>
    )
}
export default SliderSwiper;